import styled, { css } from 'styled-components'

const Title = styled.h1<ModuleTitleProps>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  ${props =>
    props.inlineHeader
      ? css`
          margin: 0 0 0 0.5rem;
        `
      : css`
          margin: 0 0 1.5rem 0;
        `}

  font-size: 2rem;
  font-weight: bold;

  & > span {
    font-weight: 600;
    font-size: 1.5rem;
  }

  ${props => props.theme.media.mobile} {
    margin: 0 0 1rem 6px;
    font-size: 1.4rem;
  }
`

interface ModuleTitleProps {
  /**
   * Determines if the styling should differ based on the title being a part
   * of a controls header.
   */
  inlineHeader?: boolean
}

/** @deprecated Use components/module-header */
export const ModuleTitle: React.JSX.CFC<ModuleTitleProps> = ({
  inlineHeader,
  children,
}) => {
  return <Title inlineHeader={inlineHeader}>{children}</Title>
}
